import { apiClient } from '@/lib/api-client';
import type { TeamView } from '@/types/api';

export const TEAM_KEY = ['team'] as const;

export const teamApi = {
  list: () => apiClient.get<TeamView>('/team'),

  /**
   * Creates the member and emails them a link to set a password.
   *
   * The invitation is a real user row from the moment it is sent, not a pending record that
   * becomes one later — so the email uniqueness constraint does the work of stopping a double
   * invitation, and there is one code path that creates a user rather than two.
   */
  invite: (email: string, name: string) =>
    apiClient.post<{ id: string; email: string; message: string }>('/team/members', {
      email,
      name,
    }),

  remove: (memberId: string) =>
    apiClient.delete<{ message: string }>(`/team/members/${encodeURIComponent(memberId)}`),
};
